/* stylelint-disable */ // Used only for files created before adding the linter -> please remove when changing the file!
$ifx_engineer: #928285; // base color

ifx-teaser-row {
  h3 {
    min-height: 48px;
  }

  .linklist {
    margin-top: 16px;
  }
}

.myInfineon-container {
  ifx-teaser-row {
    h2,
    h3,
    p,
    .copy {
      color: $ifx_engineer;
    }
  }
}




